// kabaddiStats.js
export const kabaddiStats = [
  {
    actual_name: "PlayerRaidTouchPoints",
    display_name: "RT",
  },
  {
    actual_name: "PlayerRaidBonusPoints",
    display_name: "RB",
  },
  {
    actual_name: "PlayerUnsuccessfulRaid",
    display_name: "UR",
  },
  {
    actual_name: "PlayerSuperRaid",
    display_name: "SuR",
  },
  {
    actual_name: "PlayerSuccessfulTackle",
    display_name: "ST",
  },
  {
    actual_name: "PlayerUnsuccessfulTackle",
    display_name: "UT",
  },
  {
    actual_name: "PlayerSuperTackle",
    display_name: "SuT",
  },
  {
    actual_name: "PlayerTacklePoints",
    display_name: "TP",
  },
  {
    actual_name: "Super10",
    display_name: "S10",
  },
  {
    actual_name: "High5",
    display_name: "H5",
  },
  {
    actual_name: "Dream11ProjectedFantasyPoints",
    display_name: "FP",
  },
  // ... other raider stats
];

// ... defender and all-rounder stats for Kabaddi
export const raiderStats = [
  {
    actual_name: "PlayerRaidTouchPoints",
    display_name: "RT",
  },
  {
    actual_name: "PlayerRaidBonusPoints",
    display_name: "RB",
  },
  {
    actual_name: "PlayerUnsuccessfulRaid",
    display_name: "UR",
  },
  {
    actual_name: "PlayerSuperRaid",
    display_name: "SuR",
  },
  {
    actual_name: "Super10",
    display_name: "S10",
  },
  {
    actual_name: "Dream11ProjectedFantasyPoints",
    display_name: "FP",
  },
];

export const defenderStats = [
  {
    actual_name: "PlayerSuccessfulTackle",
    display_name: "ST",
  },
  {
    actual_name: "PlayerUnsuccessfulTackle",
    display_name: "UT",
  },
  {
    actual_name: "PlayerSuperTackle",
    display_name: "SuT",
  },
  {
    actual_name: "PlayerTacklePoints",
    display_name: "TP",
  },
  {
    actual_name: "High5",
    display_name: "H5",
  },
  {
    actual_name: "Dream11ProjectedFantasyPoints",
    display_name: "FP",
  },
];

export const allRounderStats = [
  {
    actual_name: "PlayerRaidTouchPoints",
    display_name: "RT",
  },
  {
    actual_name: "PlayerRaidBonusPoints",
    display_name: "RB",
  },
  {
    actual_name: "PlayerUnsuccessfulRaid",
    display_name: "UR",
  },
  {
    actual_name: "PlayerSuperRaid",
    display_name: "SuR",
  },
  {
    actual_name: "PlayerSuccessfulTackle",
    display_name: "ST",
  },
  {
    actual_name: "PlayerUnsuccessfulTackle",
    display_name: "UT",
  },
  {
    actual_name: "PlayerSuperTackle",
    display_name: "SuT",
  },
  {
    actual_name: "PlayerTacklePoints",
    display_name: "TP",
  },
  {
    actual_name: "Dream11ProjectedFantasyPoints",
    display_name: "FP",
  },
];
